import { render, staticRenderFns } from "./FileRequestList.vue?vue&type=template&id=6432ddca&scoped=true&"
import script from "./FileRequestList.vue?vue&type=script&lang=js&"
export * from "./FileRequestList.vue?vue&type=script&lang=js&"
import style0 from "./FileRequestList.vue?vue&type=style&index=0&id=6432ddca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6432ddca",
  null
  
)

export default component.exports